import BackupTableRoundedIcon from "@mui/icons-material/BackupTableRounded";
import CopyAllIcon from "@mui/icons-material/CopyAllRounded";
import { IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import CollapseIcon from "../../icons/CollapseIcon";
import ExpandIcon from "../../icons/ExpandIcon";
import HorizontalFill from "../HorizontalFill";
import type { SqlQueryLogItem } from "./types";

interface Props {
  item: SqlQueryLogItem;
  open: boolean;
  onToggle: () => void;
}

const SqlQueryItemHeader = ({ item, open, onToggle }: Props) => {
  const [over, setOver] = useState(false);
  const hasResult = !item.resultsOmitted && item.result != null;

  const copyQuery = useCallback(() => {
    navigator.clipboard.writeText(item.queryText);
  }, [item.queryText]);

  const copyResult = useCallback(() => {
    if (!item.resultsOmitted && item.result != null) {
      navigator.clipboard.writeText(JSON.stringify(item.result));
    }
  }, [item.result, item.resultsOmitted]);

  return (
    <Stack sx={{ flex: 1 }}>
      <Stack
        direction="row"
        sx={{ flex: 1, alignItems: "center" }}
        onMouseOver={() => setOver(true)}
        onMouseLeave={() => setOver(false)}
      >
        <Stack direction="row" onClick={onToggle} sx={{ alignItems: "center", cursor: "pointer" }}>
          <IconButton aria-label={open ? "Collapse query" : "Expand query"}>
            {open ? <CollapseIcon /> : <ExpandIcon />}
          </IconButton>
          <Stack direction="row" sx={{ gap: 1, alignItems: "center" }}>
            <Typography sx={{ fontWeight: 500 }}>Query</Typography>
            <Typography>{item.executionTime / 1000}s</Typography>
            {item.recordsCount != null && <Typography color="textSecondary">{item.recordsCount} rows</Typography>}
          </Stack>
        </Stack>
        <HorizontalFill />
        <Tooltip title="Copy Query to clipboard">
          <IconButton aria-label="Copy query to clipboard" onClick={copyQuery}>
            <CopyAllIcon color={over ? "action" : "disabled"} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Copy Result to clipboard">
          <span>
            <IconButton aria-label="Copy result to clipboard" onClick={copyResult} disabled={!hasResult}>
              <BackupTableRoundedIcon color={over && hasResult ? "action" : "disabled"} />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
    </Stack>
  );
};

export default SqlQueryItemHeader;
